module.exports = __webpack_public_path__ + "fonts/trebuchet-ms.ea3fdfa6.ttf";